import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Text,
  Button,
  Checkbox,
  Accordion,
  Card,
  Avatar,
  Group,
  ScrollArea,
  Tabs,
  Modal,
} from "@mantine/core";
import { Calendar } from "@mantine/dates";

const DoctorDashboard = () => {
  const navigate = useNavigate();

  // For view appointment calendar
  const [date, setDate] = useState(new Date());

  // For set availability modal
  const [opened, setOpened] = useState(false);
  const [availabilityDate, setAvailabilityDate] = useState(new Date());
  const [b1Color, setb1Color] = useState("red");
  const [b2Color, setb2Color] = useState("red");
  const [b3Color, setb3Color] = useState("red");
  const [b4Color, setb4Color] = useState("red");
  const [b5Color, setb5Color] = useState("red");
  const [b6Color, setb6Color] = useState("red");
  const [b7Color, setb7Color] = useState("red");
  const [b8Color, setb8Color] = useState("red");
  const [b9Color, setb9Color] = useState("red");
  const [b10Color, setb10Color] = useState("red");
  const [b11Color, setb11Color] = useState("red");
  const [b12Color, setb12Color] = useState("red");
  const [b13Color, setb13Color] = useState("red");
  const [b14Color, setb14Color] = useState("red");
  const [b15Color, setb15Color] = useState("red");
  const [b16Color, setb16Color] = useState("red");
  const [b17Color, setb17Color] = useState("red");
  const [b18Color, setb18Color] = useState("red");
  const [b19Color, setb19Color] = useState("red");
  const [b20Color, setb20Color] = useState("red");
  const [b21Color, setb21Color] = useState("red");
  const [b22Color, setb22Color] = useState("red");
  const [b23Color, setb23Color] = useState("red");
  const [b24Color, setb24Color] = useState("red");

  const [patients, setPatient] = useState([
    {
      name: "Mr. Joshua K.",
      age: 24,
      gender: "Male",
      time: "10:00AM - 10:30AM",
      allergies: "Penincillin, Naproxen Sodium",
      referred: "Dr. Max Rodríguez",
      avatar:
        "https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
      concern: {
        description: "Joint pain on left knee",
        symptoms: "Joint redness, swelling, limping",
        medication: "Ibuprofen, Diclofenac, Duloxetine",
      },
    },
    {
      name: "Mr. Esikiel I.",
      age: 24,
      gender: "Male",
      time: "11:00AM - 11:30AM",
      allergies: "Penincillin, Naproxen Sodium",
      referred: "Dr. Max Rodríguez",
      avatar:
        "https://images.unsplash.com/photo-1529111290557-82f6d5c6cf85?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=393&q=80",
      concern: {
        description: "Joint pain on left knee",
        symptoms: "Joint redness, swelling, limping",
        medication: "Ibuprofen, Diclofenac, Duloxetine",
      },
    },
    {
      name: "Mr. Anthony Jaiden",
      age: 24,
      gender: "Male",
      time: "1:00AM - 1:30AM",
      allergies: "Penincillin, Naproxen Sodium",
      referred: "Dr. Max Rodríguez",
      avatar:
        "https://images.unsplash.com/photo-1615208429553-d9982932ca5c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
      concern: {
        description: "Joint pain on left knee",
        symptoms: "Joint redness, swelling, limping",
        medication: "Ibuprofen, Diclofenac, Duloxetine",
      },
    },
    {
      name: "Mrs. Liya Rose",
      age: 24,
      gender: "Feale",
      time: "2:00AM - 2:30AM",
      allergies: "Penincillin, Naproxen Sodium",
      referred: "Dr. Max Rodríguez",
      avatar:
        "https://images.unsplash.com/photo-1564805280186-5d7056d538ca?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=465&q=80",
      concern: {
        description: "Joint pain on left knee",
        symptoms: "Joint redness, swelling, limping",
        medication: "Ibuprofen, Diclofenac, Duloxetine",
      },
    },
  ]);
  const onDateChange = (e) => {
    setDate(e);
    if (e.getDate() % 2 == 0) {
      setPatient([
        {
          name: "Mr. Michael Bennard",
          age: 22,
          gender: "Male",
          time: "9:00AM - 9:30AM",
          allergies: "Anticonvulsants",
          referred: "Dr. Carol Miller",
          avatar:
            "https://images.unsplash.com/photo-1583674392771-2abf6be75965?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=467&q=80",
          concern: {
            description: "Joint pain on left knee",
            symptoms: "Joint redness, swelling, limping",
            medication: "Ibuprofen, Diclofenac, Duloxetine",
          },
        },
        {
          name: "Mrs. Sarah Pence",
          age: 22,
          gender: "Female",
          time: "1:00AM - 1:30AM",
          allergies: "Anticonvulsants, Sulfa Drugs",
          referred: "Dr. Carol Miller",
          avatar:
            "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
          concern: {
            description: "Joint pain on left knee",
            symptoms: "Joint redness, swelling, limping",
            medication: "Ibuprofen, Diclofenac, Duloxetine",
          },
        },
        {
          name: "Mr. David K.",
          age: 22,
          gender: "Male",
          time: "1:30AM - 2:30AM",
          allergies: "Anticonvulsants, Penincillin",
          referred: "Dr. Carol Miller",
          avatar:
            "https://images.unsplash.com/photo-1540569014015-19a7be504e3a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=435&q=80",
          concern: {
            description: "Joint pain on left knee",
            symptoms: "Joint redness, swelling, limping",
            medication: "Ibuprofen, Diclofenac, Duloxetine",
          },
        },
        {
          name: "Mr. Jesse E.",
          age: 22,
          gender: "Male",
          time: "2:30AM - 3:30AM",
          allergies: "Anticonvulsants, Penincillin",
          referred: "Dr. Carol Miller",
          avatar:
            "https://images.unsplash.com/photo-1611695434398-4f4b330623e6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=435&q=80",
          concern: {
            description: "Joint pain on left knee",
            symptoms: "Joint redness, swelling, limping",
            medication: "Ibuprofen, Diclofenac, Duloxetine",
          },
        },
        {
          name: "Mr. Harold S.",
          age: 22,
          gender: "Male",
          time: "3:30AM - 4:30AM",
          allergies: "Anticonvulsants, Penincillin",
          referred: "Dr. Carol Miller",
          avatar:
            "https://images.unsplash.com/photo-1500832333538-837287aad2b6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
          concern: {
            description: "Joint pain on left knee",
            symptoms: "Joint redness, swelling, limping",
            medication: "Ibuprofen, Diclofenac, Duloxetine",
          },
        },
      ]);
    } else {
      setPatient([
        {
          name: "Mr. Joshua K.",
          age: 24,
          gender: "Male",
          time: "10:00AM - 10:30AM",
          allergies: "Penincillin, Naproxen Sodium",
          referred: "Dr. Max Rodríguez",
          avatar:
            "https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
          concern: {
            description: "Joint pain on left knee",
            symptoms: "Joint redness, swelling, limping",
            medication: "Ibuprofen, Diclofenac, Duloxetine",
          },
        },
        {
          name: "Mr. Esikiel I.",
          age: 24,
          gender: "Male",
          time: "11:00AM - 11:30AM",
          allergies: "Penincillin, Naproxen Sodium",
          referred: "Dr. Max Rodríguez",
          avatar:
            "https://images.unsplash.com/photo-1529111290557-82f6d5c6cf85?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=393&q=80",
          concern: {
            description: "Joint pain on left knee",
            symptoms: "Joint redness, swelling, limping",
            medication: "Ibuprofen, Diclofenac, Duloxetine",
          },
        },
        {
          name: "Mr. Anthony Jaiden",
          age: 24,
          gender: "Male",
          time: "1:00AM - 1:30AM",
          allergies: "Penincillin, Naproxen Sodium",
          referred: "Dr. Max Rodríguez",
          avatar:
            "https://images.unsplash.com/photo-1615208429553-d9982932ca5c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
          concern: {
            description: "Joint pain on left knee",
            symptoms: "Joint redness, swelling, limping",
            medication: "Ibuprofen, Diclofenac, Duloxetine",
          },
        },
        {
          name: "Mrs. Liya Rose",
          age: 24,
          gender: "Feale",
          time: "2:00AM - 2:30AM",
          allergies: "Penincillin, Naproxen Sodium",
          referred: "Dr. Max Rodríguez",
          avatar:
            "https://images.unsplash.com/photo-1564805280186-5d7056d538ca?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=465&q=80",
          concern: {
            description: "Joint pain on left knee",
            symptoms: "Joint redness, swelling, limping",
            medication: "Ibuprofen, Diclofenac, Duloxetine",
          },
        },
      ]);
    }
  };

  const accordion = [];
  patients.forEach((patient) => {
    accordion.push(
      <Accordion.Item
        key={patient.name}
        label={
          <AccordionLabel
            image={patient.avatar}
            label={patient.name}
            description={patient.time}
          />
        }
      >
        <div>
          <Text size="sm" style={{ opacity: 0.3, fontWeight: "500" }}>
            PATIENT DESCRIPTION
          </Text>
          <Text size="sm"> Age: {patient.age} </Text>
          <Text size="sm"> Gender: {patient.gender} </Text>
          <Text size="sm"> Allergies: {patient.allergies} </Text>
          <Text size="sm">
            {" "}
            Referred by:{" "}
            <Text variant="link" component="span" inherit>
              {patient.referred}
            </Text>{" "}
          </Text>
        </div>
        <div style={{ marginTop: 20 }}>
          <Text size="sm" style={{ opacity: 0.3, fontWeight: "500" }}>
            CONCERN
          </Text>
          <Text size="sm"> Description: {patient.concern.description} </Text>
          <Text size="sm"> Symptoms: {patient.concern.symptoms} </Text>
          <Text size="sm">
            {" "}
            Current Medication: {patient.concern.medication}{" "}
          </Text>
        </div>
        <div style={{ marginTop: 20 }}>
          <Button
            variant="light"
            color="red"
            style={{ margin: 5, marginLeft: 10, marginRight: 10 }}
          >
            Reschedule Appointment
          </Button>
          <Button
            variant="light"
            color="gray"
            style={{ margin: 5, marginLeft: 10, marginRight: 10 }}
          >
            Contact
          </Button>
          <Button
            variant="light"
            style={{ margin: 5, marginLeft: 10, marginRight: 10 }}
            onClick={() => {navigate("/ehr")}}
          >
            View EHR Data
          </Button>
        </div>
      </Accordion.Item>
    );
  });

  function AccordionLabel({ label, image, description }) {
    return (
      <Group noWrap>
        <Avatar src={image} radius="xl" size="lg" />
        <div>
          <Text>{label}</Text>
          <Text size="sm" color="dimmed" weight={400}>
            {description}
          </Text>
        </div>
      </Group>
    );
  }

  function Message({ name, image, message }) {
    return (
      <Group noWrap style={{ paddingTop: 10 }}>
        <Avatar src={image} radius="xl" size="lg" />
        <div>
          <Text>{name}</Text>
          <Text size="sm" color="dimmed" weight={400}>
            {message}
          </Text>
        </div>
      </Group>
    );
  }

  return (
    <div className="Home" style={{ padding: "100px 8vw 15px 8vw" }}>
      <Card shadow="sm" padding="lg" style={{ width: "100%", height: 550 }}>
        <h2 style={{ marginBottom: 10 }}>Current Appointments</h2>
        <h4 style={{ marginBottom: 10, opacity: 0.4 }}>
          Select a date to view your appointments
        </h4>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Calendar
            style={{
              marginLeft: 15,
              boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
              borderRadius: 3,
            }}
            value={date}
            onChange={onDateChange}
          />
          <ScrollArea style={{ width: "100%", height: 400 }}>
            <div style={{ width: "90%" }}>
              <div style={{ marginLeft: 50, width: "100%" }}>
                <Accordion iconPosition="right">{accordion}</Accordion>
              </div>
            </div>
          </ScrollArea>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
          }}
        ></div>
      </Card>

      <div style={{ display: "flex", alignItems: "center", marginTop: 40 }}>
        <Card shadow="sm" padding="lg" style={{ width: "50%", height: 525 }}>
          <h2 style={{ marginBottom: 10 }}>Set Your Availability</h2>
          <h4 style={{ marginBottom: 10, opacity: 0.4 }}>
            Select a date set your availability
          </h4>
          <div style={{ marginTop: 50, marginBottom: 50 }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Calendar
                style={{
                  margin: "auto",
                  boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
                  borderRadius: 3,
                  color: "black",
                }}
                value={date}
                onChange={(e) => {
                  setOpened(true);
                  setAvailabilityDate(e);
                }}
              />
              <Modal
                centered
                overflow="inside"
                opened={opened}
                onClose={() => setOpened(false)}
              >
                <h4 style={{ textAlign: "center", marginBottom: 10 }}>
                  {" "}
                  <span style={{ color: "#A4A7AA" }}>
                    Set Availability for
                  </span>{" "}
                  {
                    [
                      "January",
                      "February",
                      "March",
                      "April",
                      "May",
                      "June",
                      "July",
                      "August",
                      "September",
                      "October",
                      "November",
                      "December",
                    ][availabilityDate.getMonth()]
                  }{" "}
                  {availabilityDate.getDate()}
                </h4>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    padding: 5,
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Button
                      variant="light"
                      color={b1Color}
                      onClick={() => {
                        setb1Color(b1Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      12:00AM - 01:00AM
                    </Button>
                    <Button
                      variant="light"
                      color={b2Color}
                      onClick={() => {
                        setb2Color(b2Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      01:00AM - 02:00AM
                    </Button>
                    <Button
                      variant="light"
                      color={b3Color}
                      onClick={() => {
                        setb3Color(b3Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      02:00AM - 03:00AM
                    </Button>
                    <Button
                      variant="light"
                      color={b4Color}
                      onClick={() => {
                        setb4Color(b4Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      03:00AM - 04:00AM
                    </Button>
                    <Button
                      variant="light"
                      color={b5Color}
                      onClick={() => {
                        setb5Color(b5Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      04:00AM - 05:00AM
                    </Button>
                    <Button
                      variant="light"
                      color={b6Color}
                      onClick={() => {
                        setb6Color(b6Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      05:00AM - 06:00AM
                    </Button>
                    <Button
                      variant="light"
                      color={b7Color}
                      onClick={() => {
                        setb7Color(b7Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      06:00AM - 07:00AM
                    </Button>
                    <Button
                      variant="light"
                      color={b8Color}
                      onClick={() => {
                        setb8Color(b8Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      07:00AM - 08:00AM
                    </Button>
                    <Button
                      variant="light"
                      color={b9Color}
                      onClick={() => {
                        setb9Color(b9Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      08:00AM - 09:00AM
                    </Button>
                    <Button
                      variant="light"
                      color={b10Color}
                      onClick={() => {
                        setb10Color(b10Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      09:00AM - 10:00AM
                    </Button>
                    <Button
                      variant="light"
                      color={b11Color}
                      onClick={() => {
                        setb11Color(b11Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      10:00AM - 11:00AM
                    </Button>
                    <Button
                      variant="light"
                      color={b12Color}
                      onClick={() => {
                        setb12Color(b12Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      11:00AM - 12:00PM
                    </Button>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Button
                      variant="light"
                      color={b13Color}
                      onClick={() => {
                        setb13Color(b13Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      12:00PM - 01:00PM
                    </Button>
                    <Button
                      variant="light"
                      color={b14Color}
                      onClick={() => {
                        setb14Color(b14Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      01:00PM- 02:00PM
                    </Button>
                    <Button
                      variant="light"
                      color={b15Color}
                      onClick={() => {
                        setb15Color(b15Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      02:00PM- 03:00PM
                    </Button>
                    <Button
                      variant="light"
                      color={b16Color}
                      onClick={() => {
                        setb16Color(b16Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      03:00PM- 04:00PM
                    </Button>
                    <Button
                      variant="light"
                      color={b17Color}
                      onClick={() => {
                        setb17Color(b17Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      04:00PM- 05:00PM
                    </Button>
                    <Button
                      variant="light"
                      color={b18Color}
                      onClick={() => {
                        setb18Color(b18Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      05:00PM- 06:00PM
                    </Button>
                    <Button
                      variant="light"
                      color={b19Color}
                      onClick={() => {
                        setb19Color(b19Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      06:00PM- 07:00PM
                    </Button>
                    <Button
                      variant="light"
                      color={b20Color}
                      onClick={() => {
                        setb20Color(b20Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      07:00PM- 08:00PM
                    </Button>
                    <Button
                      variant="light"
                      color={b21Color}
                      onClick={() => {
                        setb21Color(b21Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      08:00PM- 09:00PM
                    </Button>
                    <Button
                      variant="light"
                      color={b22Color}
                      onClick={() => {
                        setb22Color(b22Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      09:00PM- 10:00PM
                    </Button>
                    <Button
                      variant="light"
                      color={b23Color}
                      onClick={() => {
                        setb23Color(b23Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      10:00PM- 11:00PM
                    </Button>
                    <Button
                      variant="light"
                      color={b24Color}
                      onClick={() => {
                        setb24Color(b24Color === "red" ? "green" : "red");
                      }}
                      style={{ margin: 1 }}
                    >
                      11:00PM- 12:00AM
                    </Button>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 10,
                  }}
                >
                  <Button
                    radius="sm"
                    size="sm"
                    color="indigo"
                    onClick={() => setOpened(false)}
                    style={{ margin: "auto" }}
                  >
                    DONE
                  </Button>
                </div>
              </Modal>
            </div>
            <div style={{ margin: 30 }}>
              <Text align="center" size="sm" color="dimmed">
                {" "}
                Availability (Week ending on February 26):{" "}
                <strong>30 hours</strong>
              </Text>
              <Text align="center" size="sm" color="dimmed">
                {" "}
                Total booked hours: <strong>18 hours</strong>
              </Text>
            </div>
          </div>
        </Card>

        <Card
          shadow="sm"
          padding="lg"
          style={{ width: "50%", marginLeft: 40, height: 525 }}
        >
          <h2 style={{ marginBottom: 10 }}>Communications</h2>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Tabs style={{ width: "100%" }} color="indigo">
              <Tabs.Tab label="Administration (2)">
                <Message
                  name="Mr. Thomas Foggoa"
                  message="URGENT: Please update your payroll information before February 28, 2022."
                  image="https://images.unsplash.com/photo-1637684666587-91e51b10a555?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=462&q=80"
                />
                <Message
                  name="Mrs. Jenna Sheppard"
                  message="Your request for time off between March 22 and April 4 has been approved."
                  image="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
                />
              </Tabs.Tab>
              <Tabs.Tab label="Doctors (3)">
                <Message
                  name="Dr. Francesco Jamson"
                  message="The documents you have requested for patient Liya Rose (#536473) has been forwarded."
                  image="https://images.unsplash.com/photo-1537368910025-700350fe46c7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
                />
                <Message
                  name="Dr. Quintana Kerin"
                  message="Received. Thank you!"
                  image="https://images.unsplash.com/photo-1622253692010-333f2da6031d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80"
                />
                <Message
                  name="Neurology Division, Chinook Regional Hospital"
                  message="The reports were submitted to the lab."
                  image="https://images.unsplash.com/photo-1587351021355-a479a299d2f9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1172&q=80"
                />
              </Tabs.Tab>
              <Tabs.Tab label="Patients (2)">
                <Message
                  name="Mrs. Liya Rose"
                  message="Thank you, Doctor!"
                  image="https://images.unsplash.com/photo-1564805280186-5d7056d538ca?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=465&q=80"
                />
                <Message
                  name="Mr. Anthony Jaiden"
                  message="Would it be possible to reschedule the appointment to 2 AM, the same day?"
                  image="https://images.unsplash.com/photo-1615208429553-d9982932ca5c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
                />
              </Tabs.Tab>
            </Tabs>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default DoctorDashboard;
